import { HIDE_AVATAR_FOR_MESSAGE, SHOW_AVATAR_FOR_MESSAGE } from '../actionTypes/avatar';

const INITIAL_STATE = {
    hiddenAvatars: {},
};

export default function AvatarReducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case HIDE_AVATAR_FOR_MESSAGE:
            return {
                hiddenAvatars: { ...state.hiddenAvatars, [action.messageId]: true },
            };
        case SHOW_AVATAR_FOR_MESSAGE:
            return {
                hiddenAvatars: { ...state.hiddenAvatars, [action.messageId]: false },
            };
        default:
            return state;
    }
}
